/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.

import dynamic from 'next/dynamic'


import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as Container from 'src/components/Container';
import * as ContentBlock from 'src/components/ContentBlock';
import * as FEaaSWrapper from 'src/components/FEaaSWrapper';
import * as Image from 'src/components/Image';
import * as LinkList from 'src/components/LinkList';
import * as Navigation from 'src/components/Navigation';
import * as PageContent from 'src/components/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as Promo from 'src/components/Promo';
import * as RichText from 'src/components/RichText';
import * as RowSplitter from 'src/components/RowSplitter';
import * as Title from 'src/components/Title';
import * as Accordion from 'src/components/Accordions/Accordion/Accordion';
import * as AccordionItem from 'src/components/Accordions/AccordionItem/AccordionItem';
import * as AlertBanner from 'src/components/Alerts/AlertBanner/AlertBanner';
import * as AnnouncementDetail from 'src/components/Announcements/AnnouncementDetail/AnnouncementDetail';
import * as AnnouncementListing from 'src/components/Announcements/AnnouncementListing/AnnouncementListing';
import * as CountdownBanner from 'src/components/Banners/CountdownBanner/CountdownBanner';
import * as PageBannerWithOverlay from 'src/components/Banners/PageBannerWithOverlay/PageBannerWithOverlay';
import * as StandardPageBanner from 'src/components/Banners/StandardPageBanner/StandardPageBanner';
import * as EmbedCode from 'src/components/BasicContent/EmbedCode/EmbedCode';
import * as FaqItem from 'src/components/BasicContent/FAQ/FaqItem';
import * as FaqSection from 'src/components/BasicContent/FAQ/FaqSection';
import * as RichTextFull from 'src/components/BasicContent/RichText/RichTextFull';
import * as Video from 'src/components/BasicContent/Video/Video';
import * as BioDetail from 'src/components/Bio/BioDetail/BioDetail';
import * as BioGallery from 'src/components/Bio/BioGallery/BioGallery';
import * as BioListing from 'src/components/Bio/BioListing/BioListing';
import * as BioListingItem from 'src/components/Bio/BioListing/BioListingItem';
import * as CalloutBlock from 'src/components/Callouts/CalloutBlock/CalloutBlock';
import * as ImageTextCallout from 'src/components/Callouts/ImageTextCallout/ImageTextCallout';
import * as StackedIconCallout from 'src/components/Callouts/StackedIconCallout/StackedIconCallout';
import * as CoveoSimpleSearch from 'src/components/Coveo/CoveoSimpleSearch/CoveoSimpleSearch';
import * as CustomIconBulletedList from 'src/components/CustomIconBulletedList/CustomIconBulletedList';
import * as CustomIconBulletedListItem from 'src/components/CustomIconBulletedList/CustomIconBulletedListItem';
import * as DynamicButtons from 'src/components/DynamicButtons/DynamicButtons';
import * as DynamicButtonBack from 'src/components/DynamicButtons/BackButton/DynamicButtonBack';
import * as DynamicButton from 'src/components/DynamicButtons/DynamicButton/DynamicButton';
import * as DynamicButtonSection from 'src/components/DynamicButtons/DynamicButtonSection/DynamicButtonSection';
import * as DropdownOption from 'src/components/DynamicDropdown/DropdownOption';
import * as DynamicDropdown from 'src/components/DynamicDropdown/DynamicDropdown';
import * as LinkListing from 'src/components/Listings/LinkListing/LinkListing';
import * as PhotoCard from 'src/components/Listings/PhotoCardListing/PhotoCard';
import * as PhotoCardListing from 'src/components/Listings/PhotoCardListing/PhotoCardListing';
import * as ThreeColumnToutListing from 'src/components/Listings/ToutCardListing/ThreeColumnToutListing';
import * as ToutListingCard from 'src/components/Listings/ToutCardListing/ToutListingCard';
import * as DateRange from 'src/components/Locations/LocationsListing/DateRange';
import * as Location from 'src/components/Locations/LocationsListing/Location';
import * as LocationsListing from 'src/components/Locations/LocationsListing/LocationsListing';
import * as ExternalLinkWarningTypes from 'src/components/Modals/ExternalLinksWarningModal/ExternalLinkWarningTypes';
import * as ExternalLinksWarningModal from 'src/components/Modals/ExternalLinksWarningModal/ExternalLinksWarningModal';
import * as Breadcrumbs from 'src/components/Navigation/Breadcrumbs/Breadcrumbs';
import * as Footer from 'src/components/Navigation/Footer/Footer';
import * as BackButton from 'src/components/Navigation/Header/BackButton';
import * as Header from 'src/components/Navigation/Header/Header';
import * as HeaderTypes from 'src/components/Navigation/Header/HeaderTypes';
import * as HomeLink from 'src/components/Navigation/Header/HomeLink';
import * as LanguageList from 'src/components/Navigation/Header/LanguageList';
import * as LanguageSwitcher from 'src/components/Navigation/Header/LanguageSwitcher';
import * as LogoLink from 'src/components/Navigation/Header/LogoLink';
import * as MenuButton from 'src/components/Navigation/Header/MenuButton';
import * as PrimaryNav from 'src/components/Navigation/Header/PrimaryNav';
import * as PrimaryNavItem from 'src/components/Navigation/Header/PrimaryNavItem';
import * as SecondaryNav from 'src/components/Navigation/Header/SecondaryNav';
import * as Subnavigation from 'src/components/Navigation/Header/Subnavigation';
import * as SubnavigationTitle from 'src/components/Navigation/Header/SubnavigationTitle';
import * as TertiaryNav from 'src/components/Navigation/Header/TertiaryNav';
import * as TranslationLink from 'src/components/Navigation/Header/TranslationLink';
import * as UtilityLink from 'src/components/Navigation/Header/UtilityLink';
import * as UtilityNavFlyOut from 'src/components/Navigation/Header/UtilityNavFlyOut';
import * as SubnavigationItem from 'src/components/Navigation/Header/SubnavigationItem/SubnavigationItem';
import * as utilities from 'src/components/PlanData/utilities';
import * as PlanComparisonTableTypes from 'src/components/PlanData/PlanComparisonTable/PlanComparisonTable.Types';
import * as PlanComparisonTable from 'src/components/PlanData/PlanComparisonTable/PlanComparisonTable';
import * as PlanDetailsTypes from 'src/components/PlanData/PlanDetails/PlanDetails.Types';
import * as PlanDetails from 'src/components/PlanData/PlanDetails/PlanDetails';
import * as PlanDetailGroupEntriesFunctions from 'src/components/PlanData/PlanDetails/PlanDetailGroupEntries/PlanDetailGroupEntries.Functions';
import * as PlanDetailGroupEntriesTypes from 'src/components/PlanData/PlanDetails/PlanDetailGroupEntries/PlanDetailGroupEntries.Types';
import * as PlanDetailGroupEntries from 'src/components/PlanData/PlanDetails/PlanDetailGroupEntries/PlanDetailGroupEntries';
import * as PlanDocuments from 'src/components/PlanData/PlanDetails/PlanDocuments/PlanDocuments';
import * as PrescriptionDrugCoverage from 'src/components/PlanData/PlanDetails/PrescriptionDrugCoverage/PrescriptionDrugCoverage';
import * as PlanOptionsListingGraphQL from 'src/components/PlanData/PlanOptionsListingGraphQL/PlanOptionsListingGraphQL';
import * as PlanSearch from 'src/components/PlanData/PlanSearch/PlanSearch';
import * as CountiesType from 'src/components/PlanData/Types/Counties.Type';
import * as DrugCoverageTablesType from 'src/components/PlanData/Types/DrugCoverageTables.Type';
import * as GetPlanDetailsResponseType from 'src/components/PlanData/Types/GetPlanDetailsResponse.Type';
import * as PlanAdditionalBenefitsType from 'src/components/PlanData/Types/PlanAdditionalBenefits.Type';
import * as PlanDetailGroupType from 'src/components/PlanData/Types/PlanDetailGroup.Type';
import * as PlanDocumentsType from 'src/components/PlanData/Types/PlanDocuments.Type';
import * as PlanFeaturedEntriesType from 'src/components/PlanData/Types/PlanFeaturedEntries.Type';
import * as PlanTypesType from 'src/components/PlanData/Types/PlanTypes.Type';
import * as PlanYearType from 'src/components/PlanData/Types/PlanYear.Type';
import * as PlansType from 'src/components/PlanData/Types/Plans.Type';
import * as StarRatingsType from 'src/components/PlanData/Types/StarRatings.Type';
import * as ZIPCodeSearchTypes from 'src/components/PlanData/ZIPCodeSearch/ZIPCodeSearch.Types';
import * as ZIPCodeSearch from 'src/components/PlanData/ZIPCodeSearch/ZIPCodeSearch';
import * as PolicyDocSearch from 'src/components/PolicyDocSearch/PolicyDocSearch';
import * as BlogLinkListing from 'src/components/RSSDisplay/BlogLinkListing/BlogLinkListing';
import * as PodcastListing from 'src/components/RSSDisplay/PodcastListing/PodcastListing';
import * as DatasourceWithChildrenContentResolver from 'src/components/Samples/DatasourceWithChildrenContentResolver';
import * as DefaultRenderingContentResolver from 'src/components/Samples/DefaultRenderingContentResolver';
import * as Error500Throw from 'src/components/Samples/Error500Throw';
import * as GraphQLSamples from 'src/components/Samples/GraphQLSamples';
import * as IconSystem from 'src/components/Samples/IconSystem';
import * as ResponsiveImageSample from 'src/components/Samples/ResponsiveImageSample';
import * as SignInBanner from 'src/components/SignIn/SignInBanner';
import * as SignIn5050 from 'src/components/SignIn/SignIn5050/SignIn5050';
import * as Container3070 from 'src/components/Structural/Container3070/Container3070';
import * as Container4Column from 'src/components/Structural/Container4Column/Container4Column';
import * as Container5050 from 'src/components/Structural/Container5050/Container5050';
import * as Container70 from 'src/components/Structural/Container70/Container70';
import * as ContainerThreeColumns from 'src/components/Structural/ContainerThreeColumns/ContainerThreeColumns';
import * as HorizontalDivider from 'src/components/Structural/HorizontalDivider/HorizontalDivider';
import * as Tab from 'src/components/Tabs/Tab/Tab';
import * as TabList from 'src/components/Tabs/TabList/TabList';
import * as StyleguideFieldUsageCheckbox from 'src/components/fields/Styleguide-FieldUsage-Checkbox';
import * as StyleguideFieldUsageContentList from 'src/components/fields/Styleguide-FieldUsage-ContentList';
import * as StyleguideFieldUsageCustom from 'src/components/fields/Styleguide-FieldUsage-Custom';
import * as StyleguideFieldUsageDate from 'src/components/fields/Styleguide-FieldUsage-Date';
import * as StyleguideFieldUsageFile from 'src/components/fields/Styleguide-FieldUsage-File';
import * as StyleguideFieldUsageImage from 'src/components/fields/Styleguide-FieldUsage-Image';
import * as StyleguideFieldUsageItemLink from 'src/components/fields/Styleguide-FieldUsage-ItemLink';
import * as StyleguideFieldUsageLink from 'src/components/fields/Styleguide-FieldUsage-Link';
import * as StyleguideFieldUsageNumber from 'src/components/fields/Styleguide-FieldUsage-Number';
import * as StyleguideFieldUsageRichText from 'src/components/fields/Styleguide-FieldUsage-RichText';
import * as StyleguideFieldUsageText from 'src/components/fields/Styleguide-FieldUsage-Text';
const GraphQLConnectedDemo = {
  module: () => import('src/components/graphql/GraphQL-ConnectedDemo.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/graphql/GraphQL-ConnectedDemo.dynamic')?.default : dynamic(GraphQLConnectedDemo.module)
}
import * as GraphQLIntegratedDemo from 'src/components/graphql/GraphQL-IntegratedDemo';
import * as GraphQLLayout from 'src/components/graphql/GraphQL-Layout';
import * as Button from 'src/components/helpers/Button/Button';
import * as Combobox from 'src/components/helpers/Combobox/Combobox';
import * as ConditionalWrapper from 'src/components/helpers/ConditionalWrapper/ConditionalWrapper';
import * as Icon from 'src/components/helpers/Icon/Icon';
import * as Link from 'src/components/helpers/Link/Link';
import * as Listbox from 'src/components/helpers/Listbox/Listbox';
import * as Loader from 'src/components/helpers/Loader/Loader';
import * as Modal from 'src/components/helpers/Modal/Modal';
import * as Types from 'src/components/helpers/Modal/Types';
import * as Option from 'src/components/helpers/Option/Option';
import * as ResponsiveImages from 'src/components/helpers/ResponsiveImages/ResponsiveImages';
import * as RichTextWrapper from 'src/components/helpers/RichText/RichTextWrapper';
import * as ScriptTags from 'src/components/helpers/ScriptTags/ScriptTags';
import * as Select from 'src/components/helpers/Select/Select';
import * as Table from 'src/components/helpers/Table/Table';
import * as Tabletypes from 'src/components/helpers/Table/Table.types';
import * as TextInputFunctions from 'src/components/helpers/TextInput/TextInput.Functions';
import * as TextInput from 'src/components/helpers/TextInput/TextInput';
import * as Tooltip from 'src/components/helpers/Tooltip/Tooltip';
import * as TooltipFunctions from 'src/components/helpers/Tooltip/TooltipFunctions';
import * as TooltipTypes from 'src/components/helpers/Tooltip/TooltipTypes';
import * as StyleguideComponentParams from 'src/components/styleguide/Styleguide-ComponentParams';
import * as StyleguideCustomRouteType from 'src/components/styleguide/Styleguide-CustomRouteType';
import * as StyleguideEditFrame from 'src/components/styleguide/Styleguide-EditFrame';
import * as StyleguideLayoutReuse from 'src/components/styleguide/Styleguide-Layout-Reuse';
import * as StyleguideLayoutTabsTab from 'src/components/styleguide/Styleguide-Layout-Tabs-Tab';
import * as StyleguideLayoutTabs from 'src/components/styleguide/Styleguide-Layout-Tabs';
import * as StyleguideLayout from 'src/components/styleguide/Styleguide-Layout';
import * as StyleguideMultilingual from 'src/components/styleguide/Styleguide-Multilingual';
import * as StyleguideRouteFields from 'src/components/styleguide/Styleguide-RouteFields';
import * as StyleguideSection from 'src/components/styleguide/Styleguide-Section';
import * as StyleguideSitecoreContext from 'src/components/styleguide/Styleguide-SitecoreContext';
import * as StyleguideSpecimen from 'src/components/styleguide/Styleguide-Specimen';
import * as StyleguideTracking from 'src/components/styleguide/Styleguide-Tracking';

const components = new Map();

components.set('ColumnSplitter', ColumnSplitter);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('FEaaSWrapper', FEaaSWrapper);
components.set('Image', Image);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Promo', Promo);
components.set('RichText', RichText);
components.set('RowSplitter', RowSplitter);
components.set('Title', Title);
components.set('Accordion', Accordion);
components.set('AccordionItem', AccordionItem);
components.set('AlertBanner', AlertBanner);
components.set('AnnouncementDetail', AnnouncementDetail);
components.set('AnnouncementListing', AnnouncementListing);
components.set('CountdownBanner', CountdownBanner);
components.set('PageBannerWithOverlay', PageBannerWithOverlay);
components.set('StandardPageBanner', StandardPageBanner);
components.set('EmbedCode', EmbedCode);
components.set('FaqItem', FaqItem);
components.set('FaqSection', FaqSection);
components.set('RichTextFull', RichTextFull);
components.set('Video', Video);
components.set('BioDetail', BioDetail);
components.set('BioGallery', BioGallery);
components.set('BioListing', BioListing);
components.set('BioListingItem', BioListingItem);
components.set('CalloutBlock', CalloutBlock);
components.set('ImageTextCallout', ImageTextCallout);
components.set('StackedIconCallout', StackedIconCallout);
components.set('CoveoSimpleSearch', CoveoSimpleSearch);
components.set('CustomIconBulletedList', CustomIconBulletedList);
components.set('CustomIconBulletedListItem', CustomIconBulletedListItem);
components.set('DynamicButtons', DynamicButtons);
components.set('DynamicButtonBack', DynamicButtonBack);
components.set('DynamicButton', DynamicButton);
components.set('DynamicButtonSection', DynamicButtonSection);
components.set('DropdownOption', DropdownOption);
components.set('DynamicDropdown', DynamicDropdown);
components.set('LinkListing', LinkListing);
components.set('PhotoCard', PhotoCard);
components.set('PhotoCardListing', PhotoCardListing);
components.set('ThreeColumnToutListing', ThreeColumnToutListing);
components.set('ToutListingCard', ToutListingCard);
components.set('DateRange', DateRange);
components.set('Location', Location);
components.set('LocationsListing', LocationsListing);
components.set('ExternalLinkWarningTypes', ExternalLinkWarningTypes);
components.set('ExternalLinksWarningModal', ExternalLinksWarningModal);
components.set('Breadcrumbs', Breadcrumbs);
components.set('Footer', Footer);
components.set('BackButton', BackButton);
components.set('Header', Header);
components.set('HeaderTypes', HeaderTypes);
components.set('HomeLink', HomeLink);
components.set('LanguageList', LanguageList);
components.set('LanguageSwitcher', LanguageSwitcher);
components.set('LogoLink', LogoLink);
components.set('MenuButton', MenuButton);
components.set('PrimaryNav', PrimaryNav);
components.set('PrimaryNavItem', PrimaryNavItem);
components.set('SecondaryNav', SecondaryNav);
components.set('Subnavigation', Subnavigation);
components.set('SubnavigationTitle', SubnavigationTitle);
components.set('TertiaryNav', TertiaryNav);
components.set('TranslationLink', TranslationLink);
components.set('UtilityLink', UtilityLink);
components.set('UtilityNavFlyOut', UtilityNavFlyOut);
components.set('SubnavigationItem', SubnavigationItem);
components.set('utilities', utilities);
components.set('PlanComparisonTable.Types', PlanComparisonTableTypes);
components.set('PlanComparisonTable', PlanComparisonTable);
components.set('PlanDetails.Types', PlanDetailsTypes);
components.set('PlanDetails', PlanDetails);
components.set('PlanDetailGroupEntries.Functions', PlanDetailGroupEntriesFunctions);
components.set('PlanDetailGroupEntries.Types', PlanDetailGroupEntriesTypes);
components.set('PlanDetailGroupEntries', PlanDetailGroupEntries);
components.set('PlanDocuments', PlanDocuments);
components.set('PrescriptionDrugCoverage', PrescriptionDrugCoverage);
components.set('PlanOptionsListingGraphQL', PlanOptionsListingGraphQL);
components.set('PlanSearch', PlanSearch);
components.set('Counties.Type', CountiesType);
components.set('DrugCoverageTables.Type', DrugCoverageTablesType);
components.set('GetPlanDetailsResponse.Type', GetPlanDetailsResponseType);
components.set('PlanAdditionalBenefits.Type', PlanAdditionalBenefitsType);
components.set('PlanDetailGroup.Type', PlanDetailGroupType);
components.set('PlanDocuments.Type', PlanDocumentsType);
components.set('PlanFeaturedEntries.Type', PlanFeaturedEntriesType);
components.set('PlanTypes.Type', PlanTypesType);
components.set('PlanYear.Type', PlanYearType);
components.set('Plans.Type', PlansType);
components.set('StarRatings.Type', StarRatingsType);
components.set('ZIPCodeSearch.Types', ZIPCodeSearchTypes);
components.set('ZIPCodeSearch', ZIPCodeSearch);
components.set('PolicyDocSearch', PolicyDocSearch);
components.set('BlogLinkListing', BlogLinkListing);
components.set('PodcastListing', PodcastListing);
components.set('DatasourceWithChildrenContentResolver', DatasourceWithChildrenContentResolver);
components.set('DefaultRenderingContentResolver', DefaultRenderingContentResolver);
components.set('Error500Throw', Error500Throw);
components.set('GraphQLSamples', GraphQLSamples);
components.set('IconSystem', IconSystem);
components.set('ResponsiveImageSample', ResponsiveImageSample);
components.set('SignInBanner', SignInBanner);
components.set('SignIn5050', SignIn5050);
components.set('Container3070', Container3070);
components.set('Container4Column', Container4Column);
components.set('Container5050', Container5050);
components.set('Container70', Container70);
components.set('ContainerThreeColumns', ContainerThreeColumns);
components.set('HorizontalDivider', HorizontalDivider);
components.set('Tab', Tab);
components.set('TabList', TabList);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('Button', Button);
components.set('Combobox', Combobox);
components.set('ConditionalWrapper', ConditionalWrapper);
components.set('Icon', Icon);
components.set('Link', Link);
components.set('Listbox', Listbox);
components.set('Loader', Loader);
components.set('Modal', Modal);
components.set('Types', Types);
components.set('Option', Option);
components.set('ResponsiveImages', ResponsiveImages);
components.set('RichTextWrapper', RichTextWrapper);
components.set('ScriptTags', ScriptTags);
components.set('Select', Select);
components.set('Table', Table);
components.set('Table.types', Tabletypes);
components.set('TextInput.Functions', TextInputFunctions);
components.set('TextInput', TextInput);
components.set('Tooltip', Tooltip);
components.set('TooltipFunctions', TooltipFunctions);
components.set('TooltipTypes', TooltipTypes);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-EditFrame', StyleguideEditFrame);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Specimen', StyleguideSpecimen);
components.set('Styleguide-Tracking', StyleguideTracking);

// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// componentModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// componentFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.
// Editing mode doesn't work well with dynamic components in nextjs: dynamic components are not displayed without refresh after a rendering is added. 
// This happens beacuse Sitecore editors simply insert updated HTML generated on server side. This conflicts with nextjs dynamic logic as no HTML gets rendered for dynamic component
// So we use require() to obtain dynamic components in editing mode while preserving dynamic logic for non-editing scenarios
// As we need to be able to seamlessly work with dynamic components in both editing and normal modes, different componentFactory functions will be passed to app

export function componentModule(componentName: string) {
  const component = components.get(componentName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}

function baseComponentFactory(componentName: string, exportName?: string, isEditing?: boolean) {
  const DEFAULT_EXPORT_NAME = 'Default';
  const component = components.get(componentName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element(isEditing);
  }

  if (exportName && exportName !== DEFAULT_EXPORT_NAME) {
    return component[exportName];
  }

  return component?.Default || component?.default || component;
}
  
export function componentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, false);
}

export function editingComponentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, true);
}
